import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "@/components/dialog";
import { Button } from "@/components/button";
import { useQueryGetGroupList } from "@/apis/groups/getGroupList";

export interface FilterState {
  gradeFilter:
    | "all"
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12";
  groupFilter: string; // "all" or group ID
}

interface FilteringUserListModalProps {
  open: boolean;
  onClose: () => void;
  onApply: (filters: FilterState) => void;
  currentFilters: FilterState;
}

const FilteringUserListModal: React.FC<FilteringUserListModalProps> = ({
  open,
  onClose,
  onApply,
  currentFilters,
}) => {
  // Temporary filter state for modal
  const [tempFilters, setTempFilters] = useState<FilterState>(currentFilters);

  // Get group list for dropdown
  const { data: groupsData } = useQueryGetGroupList(
    { limit: 100 }, // Get all groups
    { enabled: open }
  );

  // Update tempFilters when modal opens with current filters
  useEffect(() => {
    if (open) {
      setTempFilters(currentFilters);
    }
  }, [open, currentFilters]);

  const handleApply = () => {
    onApply(tempFilters);
    onClose();
  };

  const handleCancel = () => {
    setTempFilters(currentFilters);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} size="md">
      <DialogTitle>Filter Students</DialogTitle>
      <DialogBody className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Grade
          </label>
          <select
            value={tempFilters.gradeFilter}
            onChange={(e) =>
              setTempFilters((prev) => ({
                ...prev,
                gradeFilter: e.target.value as FilterState["gradeFilter"],
              }))
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">All Grades</option>
            <option value="1">Grade 1</option>
            <option value="2">Grade 2</option>
            <option value="3">Grade 3</option>
            <option value="4">Grade 4</option>
            <option value="5">Grade 5</option>
            <option value="6">Grade 6</option>
            <option value="7">Grade 7</option>
            <option value="8">Grade 8</option>
            <option value="9">Grade 9</option>
            <option value="10">Grade 10</option>
            <option value="11">Grade 11</option>
            <option value="12">Grade 12</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Group
          </label>
          <select
            value={tempFilters.groupFilter}
            onChange={(e) =>
              setTempFilters((prev) => ({
                ...prev,
                groupFilter: e.target.value,
              }))
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">All Groups</option>
            {groupsData?.items?.map((group) => (
              <option key={group.id} value={group.id}>
                {group.name}
              </option>
            ))}
          </select>
        </div>
      </DialogBody>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleApply}>Apply Filters</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilteringUserListModal;
